import { Injectable } from '@angular/core';
import { App, Platform, Events } from 'ionic-angular';

import { User }  from '../user/user';
import { Api } from '../api/api';
import { Utils } from '../utils/utils';
import { IPTV } from '../iptv/iptv';


/*
*
*  Services Provider
*
*/

@Injectable()
export class Services {


    constructor(
        public application: App,
        public events: Events,
        public user: User,
        public api: Api,
        public IPTV: IPTV,
        public platform: Platform,
        public utils: Utils
    ) {

    }

    /*
    *    Check if Encoder is OK for current user
    */
    check() {

        return new Promise((resolve, reject) => {

            if (!this.user.isLogged()) return reject();
            if (!this.IPTV.contract) return reject();
            if (!this.IPTV.encoder) return reject();
            if (!this.IPTV.boxs) return reject();

            this.getData().then((data:any) => {
                
                if (!data) {
                    this.events.publish('iptv:off');
                    return reject('DEALLOCATE');
                }

                if (!data.encoder) {
                    this.events.publish('iptv:off');
                    return reject('DEALLOCATE');
                }

                if (this.IPTV.encoder.attribution_source != 'RESERVED') {
                    if (data.encoder.id_contact != this.user.data.id) {
                        this.events.publish('iptv:off');
                        return reject('DEALLOCATE');
                    }
                } 

                if (JSON.stringify(this.IPTV.contract.parc) != JSON.stringify(data.parc)) {
                    this.IPTV.contract.parc = data.parc;
                    this.events.publish('contract:update');
                }

                if (JSON.stringify(this.IPTV.boxs) != JSON.stringify(data.boxs)) {
                    this.IPTV.boxs = data.boxs;
                    this.events.publish('sources:update');
                }

                if (data.encoder.id_box != this.IPTV.box.id || data.encoder.id_resolution != this.IPTV.resolution.id) {
                    this.IPTV.encoder = data.encoder;
                }

                if (data.encoder.id_box != this.IPTV.box.id) {
                    this.IPTV.setSourceFromEncoder();
                    this.events.publish('app:refresh');
                    this.events.publish('source:update');
                }

                if (data.encoder.id_resolution != this.IPTV.resolution.id) {
                    this.IPTV.setResolutionFromEncoder();
                    this.events.publish('resolution:update');
                }

                resolve();

            }, (err) => {
                return reject(err);
            });
        });
    }
    

    /*
    *    Get changes from API
    */
    getData() {
        return new Promise((resolve, reject) => {
            this.api.get('iptv/data').subscribe((response:any)=>{
                resolve(response.result.result);
            },(err) => {
                reject(err);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/providers/services/services.ts